import { getPermissionOptions } from "../../../utils/userConfig";

/**
 * This is the detault columns for District Users
 * field - This is the property on the object that wil be displayed within this column
 * headerName - This is the header that will be displayed for the column
 * hideableable: This is a custom field that will determine whether a column will be able to be added to the grid or not (visibility)
 */
export const getDistrictUsersColumns = async (data) => {
  return [
    {
      field: "firstName",
      secondField: "lastName",
      fieldConfig: "combined",
      headerName: "Users",
      showColumn: true,
      cellType: "userName",
      showAdd: false,
      filterType: "text",
    },
    {
      field: "schoolName",
      headerName: "School",
      cellType: "text",
      showColumn: true,
      showAdd: false,
      filterType: "select",
    },
    {
      field: "permission",
      headerName: "Role",
      cellType: "chip",
      filterType: "select",
      typeConfig: {
        colors: {
          "District Admin": "lightblue",
          "School Admin": "yellow",
          Responder: "blue",
          "Super Admin": "lightpurple",
        },
      },
      displayConfig: {
        districtAdmin: "District Admin",
        schoolAdmin: "School Admin",
        responder: "Responder",
        disclosureAdmin: "Super Admin",
      },
      showColumn: true,
      showAdd: true,
      required: true,
      disabled: true,
      addDefaultValue: "districtAdmin",
      type: "select",
      otpions: [{ value: "districtAdmin", label: "District Admin" }],
      dataType: "string",
      options: await getPermissionOptions("districtAdmin"),
    },
    {
      field: "availability",
      headerName: "Availability",
      cellType: "Availability",
      typeConfig: {
        colors: {
          Available: "green",
          "Out of Office": "red",
        },
      },
      showColumn: true,
      showAdd: false,
      filterType: "select",
    },
    {
      field: 'firstName',
      headerName: 'First Name',
      cellType: 'text',
      showColumn: false,
      showAdd: true,
      required: true,
      type: 'text',
      dataType: 'string',
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        cellType: 'text',
        showColumn: false,
        showAdd: true,
        required: true,
        type: 'text',
        dataType: 'string',
    },
    {
        field: 'email',
        headerName: 'Email',
        cellType: 'text',
        showColumn: false,
        showAdd: true,
        required: true,
        type: 'text',
        dataType: 'email',
    },
    {
        field: 'phone',
        headerName: 'Phone',
        cellType: 'text',
        showColumn: false,
        showAdd: true,
        required: true,
        type: 'text',
        dataType: 'phone',
    },
    {
        field: 'district',
        headerName: 'District',
        cellType: 'text',
        showColumn: false,
        showAdd: true,
        addDefaultValue: data.id,
        disabled: true,
        required: true,
        type: 'select',
        options: [{value: data.id, label: data.name}],
        dataType: 'string',
    }
  ];
};

// Page-header filters intentionally removed (#125): School, Role, and Availability are now
// searchable multi-select filters in the table headers themselves. Per the UX directive, the
// page-header filter bar is only for filters that can't live in the table.
export const getDistrictUsersFilters = async () => {
  return [];
};
